import React from "react";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const UserFooter = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <footer className="w-full bg-[#F9F9F9] py-8 px-4 sm:px-6 md:px-10 lg:px-16 border-t grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-y-6 md:gap-y-8">
        {/* About Section */}
        <div className="flex flex-col col-span-1 lg:col-span-2">
          <h3 className="font-bold tracking-wide text-[22px] text-[#0070A8] border-b-2 border-[#0070A8] pb-2 w-[90%]">
            About
          </h3>
          <div className="py-6 grid grid-cols-2 gap-2">
            <button
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Accrediations
            </button>
            <button
              onClick={() => {
                navigate("/about");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Vision 20-25
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              Renewal ISO
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              Accrediations Statement
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              Rights of Clients
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              Disclaimer Policy
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              Legal & Compliance Information
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              Refund & Cancellation Policy
            </button>
            <button
              onClick={() => {
                navigate("/news&blogs");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Public Notice
            </button>
            <button
              onClick={() => {
                navigate("/contact");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Complaints Management
            </button>
          </div>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col col-span-1 lg:col-span-1">
          <h3 className="font-bold tracking-wide text-[22px] text-[#0070A8] border-b-2 border-[#0070A8] pb-2 w-[90%]">
            Quick Links
          </h3>
          <div className="py-6 flex flex-col gap-2">
            <button
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Home
            </button>
            <button
              onClick={() => {
                navigate("/about");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              About Us
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              ISO Certificates
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left">
              Compliance Certificates
            </button>
            {/* <button
              onClick={() => {
                navigate("/news&blogs");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              News & Blogs
            </button> */}
            <button
              onClick={() => {
                navigate("/apply-for-franchise");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Apply for Franchise
            </button>
            <button
              onClick={() => {
                navigate("/consultant-enquiries");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Consultant Registration Form
            </button>
            <button
              onClick={() => {
                navigate("/contact");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="font-normal text-sm text-[#1A1A1A] hover:text-[#0070A8] hover:underline text-left"
            >
              Contact Us
            </button>
          </div>
        </div>

        {/* Useful Links */}
        <div className="flex flex-col col-span-1 lg:col-span-1">
          <h3 className="font-bold tracking-wide text-[22px] text-[#0070A8] border-b-2 border-[#0070A8] pb-2 w-[90%]">
            Useful Links
          </h3>
          <div className="py-6 flex flex-col gap-2">
            <button className="font-normal text-sm text-[#1A1A1A] text-left">
              Privacy Policy
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] text-left">
              Disclaimer
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] text-left">
              Terms & Conditions
            </button>
            <button className="font-normal text-sm text-[#1A1A1A] text-left">
              FAQ
            </button>
          </div>
        </div>

        {/* Contact Us */}
        <div className="flex flex-col col-span-1 lg:col-span-2">
          <h3 className="font-bold tracking-wide text-[22px] text-[#0070A8] border-b-2 border-[#0070A8] pb-2 w-[90%]">
            Contact Us
          </h3>
          <div className="py-6 flex flex-col gap-2">
            <div className="flex items-center gap-2 px-2">
              <FaPhoneAlt className="text-[#29AAE1] text-sm" size={18} />
              <span className="text-[#1A1A1A] text-sm">
                +91 9337233933, +91 7326979740 +91 9583146761
              </span>
            </div>
            <div className="flex items-center gap-2 px-2">
              <FaEnvelope className="text-[#29AAE1] text-sm" size={18} />
              <span className="text-[#1A1A1A] text-sm">
                icvcerification2011@gmail.com
              </span>
            </div>
            <div className="flex items-center gap-1 py-2 px-2">
              <FaLocationDot className="text-[#29AAE1] font-bold" size={18} />
              <span className="text-[#1A1A1A] text-sm">
                M/44, 2nd Floor, Basanti Colony, Rourkela, Pin- 769012
              </span>
            </div>
          </div>
        </div>
      </footer>

      {/* Web Bocket */}
      <div className="w-full bg-[#001A2C] text-[#E7E7E7] text-sm hidden md:flex justify-center items-center px-4 sm:px-6 md:px-10 py-2">
        <p>ICV Certification - India. © {currentYear}. All Rights Reserved.</p>
        {/* <p>
          Made with <span className="text-red-600">❤</span> by - Web Bocket.
        </p> */}
      </div>
    </React.Fragment>
  );
};

export default UserFooter;
